<template>
  <el-col
    class="content"
    :xl="{ span: 18 }"
    :lg="{ span: 18 }"
    :md="{ span: 18 }"
    :xs="{ span: 24 }"
    :sm="{ span: 24 }"
  >
    <el-row class="mydoc">
      <el-col class="header" style="font-weight: 900">
        <el-button
          icon="el-icon-back"
          size="small"
          @click="goBack"
          style="float: left; margin-right: 10px"
        >
          {{ $t('preprint.detailBack') }}
        </el-button>
        {{ $t('preprint.detailTitle') }}
      </el-col>
      <el-col class="mybody">
        <div v-if="preprint.id">
          <!-- 基本信息 -->
          <el-card shadow="never" style="margin-bottom: 20px">
            <div slot="header" style="font-size: 18px; font-weight: 900; color: #006a71">
              {{ preprint.title }}
            </div>
            <el-row>
              <el-col :span="24" style="margin-bottom: 10px">
                <el-tag size="small" type="info">{{ preprint.preprintType }}</el-tag>
                <span style="margin-left: 20px; color: #909399">
                  {{ $t('preprint.myNumber') }}: {{ preprint.preprintNumber }}
                </span>
              </el-col>
              <el-col :span="24" style="margin-bottom: 10px">
                <span style="font-weight: 900; color: #006a71">{{ $t('preprint.detailAuthors') }}:</span>
                <span v-for="(author, index) in preprint.authors" :key="index">
                  {{ author.authorName }}
                  <el-tag v-if="author.isCorresponding === 1" size="mini" type="success">
                    {{ $t('preprint.detailCorresponding') }}
                  </el-tag>
                  ({{ author.authorAffiliation }})
                  <span v-if="index < preprint.authors.length - 1">, </span>
                </span>
              </el-col>
              <el-col :span="24" style="margin-bottom: 10px">
                <span style="font-weight: 900; color: #006a71">{{ $t('preprint.detailAbstract') }}:</span>
                <p style="margin-top: 5px; line-height: 1.8">
                  {{ preprint.abstractText }}
                </p>
              </el-col>
              <el-col :span="24" style="margin-bottom: 10px">
                <span style="font-weight: 900; color: #006a71">{{ $t('preprint.detailKeywords') }}:</span>
                {{ preprint.keywords }}
              </el-col>
              <el-col :span="24" style="margin-bottom: 10px; color: #909399">
                <i class="el-icon-view"></i> {{ $t('preprint.detailView') }} {{ preprint.viewCount }}
                &nbsp;&nbsp;
                <i class="el-icon-download"></i> {{ $t('preprint.detailDownload') }} {{ preprint.downloadCount }}
                &nbsp;&nbsp;
                <i class="el-icon-chat-dot-round"></i> {{ $t('preprint.detailComment') }} {{ preprint.commentCount }}
                &nbsp;&nbsp;&nbsp;&nbsp;
                {{ $t('preprint.detailSubmitTime') }}: {{ preprint.submitTime }}
              </el-col>
              <el-col :span="24" style="margin-top: 20px">
                <el-button
                  type="primary"
                  icon="el-icon-download"
                  @click="downloadFile"
                  style="background-color: #0a666b; border: none"
                >
                  {{ $t('preprint.detailDownloadButton') }}
                </el-button>
              </el-col>
            </el-row>
          </el-card>

          <!-- 评论区 -->
          <el-card shadow="never">
            <div slot="header" style="font-weight: 900; color: #006a71">
              {{ $t('preprint.detailCommentsTitle', { count: commentList.length }) }}
            </div>

            <!-- 评论列表 -->
            <div v-if="commentList.length > 0">
              <div
                v-for="(comment, index) in commentList"
                :key="index"
                style="margin-bottom: 20px; padding-bottom: 15px; border-bottom: 1px solid #eee"
              >
                <div style="font-weight: 900; color: #006a71">
                  {{ comment.commenterName }}
                  <span style="font-weight: normal; color: #909399; font-size: 12px; margin-left: 10px">
                    {{ comment.commentTime }}
                  </span>
                  <!-- 删除按钮：评论本人或审核编辑可见 -->
                  <el-button
                    v-if="canDeleteComment(comment)"
                    type="text"
                    size="small"
                    style="color: #F56C6C; float: right"
                    @click="handleDeleteComment(comment.id)"
                  >
                    <i class="el-icon-delete"></i> {{ $t('preprint.detailDeleteComment') }}
                  </el-button>
                </div>
                <div style="margin-top: 8px; line-height: 1.6">
                  {{ comment.commentContent }}
                </div>
              </div>
            </div>
            <el-empty v-else :description="$t('preprint.detailNoComments')" :image-size="80"></el-empty>

            <!-- 提交评论表单 -->
            <div v-if="userInfo" style="margin-top: 30px">
              <el-divider></el-divider>
              <div style="font-weight: 900; color: #006a71; margin-bottom: 10px">
                {{ $t('preprint.detailAddComment') }}
              </div>
              <el-input
                type="textarea"
                :rows="4"
                :placeholder="$t('preprint.detailCommentPlaceholder')"
                v-model="commentContent"
                maxlength="500"
                show-word-limit
              >
              </el-input>
              <el-button
                type="primary"
                @click="submitComment"
                style="margin-top: 10px; background-color: #0a666b; border: none"
                :loading="submittingComment"
              >
                {{ $t('preprint.detailSubmitComment') }}
              </el-button>
            </div>
            <div v-else style="margin-top: 30px; text-align: center; color: #909399">
              <el-divider></el-divider>
              {{ $t('preprint.detailLoginToComment') }}
            </div>
          </el-card>
        </div>

        <!-- 加载中 -->
        <div v-else style="text-align: center; padding: 50px">
          <i class="el-icon-loading" style="font-size: 30px; color: #0a666b"></i>
          <p style="margin-top: 10px; color: #909399">{{ $t('preprint.detailLoading') }}</p>
        </div>
      </el-col>
    </el-row>
  </el-col>
</template>

<script>
import {
  getPreprintDetail,
  getCommentList,
  submitComment,
  incrementViewCount,
  incrementDownloadCount,
  deleteComment
} from '@/api/preprint'
import config from '@/config'

export default {
  name: 'preprintDetail',
  data() {
    return {
      preprintId: '',
      preprint: {},
      commentList: [],
      commentContent: '',
      submittingComment: false,
      userInfo: null
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    loadPreprintDetail() {
      getPreprintDetail({
        id: this.preprintId
      }).then((res) => {
        if (res.data.errorCode === 0) {
          this.preprint = res.data.result || {}
          // 如果没有authors数组，使用submitterName
          if (!this.preprint.authors || this.preprint.authors.length === 0) {
            this.preprint.authors = [{
              authorName: this.preprint.submitterName || '未知',
              authorAffiliation: '',
              isCorresponding: 0
            }]
          }
          // 增加浏览次数
          this.incrementView()
          // 加载评论
          this.loadComments()
        } else {
          this.$message.error(res.data.errorMessage || this.$t('preprint.detailLoadFailed'))
        }
      }).catch((err) => {
        console.error('加载预印本详情错误:', err)
        this.$message.error(this.$t('preprint.detailLoadFailed'))
      })
    },
    loadComments() {
      getCommentList({
        preprintId: this.preprintId,
        current: 1,
        size: 100
      }).then((res) => {
        if (res.data.errorCode === 0) {
          this.commentList = res.data.result.records || []
        }
      }).catch((err) => {
        console.error('加载评论列表错误:', err)
      })
    },
    incrementView() {
      incrementViewCount({
        id: this.preprintId
      }).catch((err) => {
        console.error('增加浏览次数错误:', err)
      })
    },
    downloadFile() {
      // 增加下载次数
      incrementDownloadCount({
        id: this.preprintId
      }).then(() => {
        // 更新下载计数显示
        this.preprint.downloadCount = (this.preprint.downloadCount || 0) + 1
      }).catch((err) => {
        console.error('增加下载次数错误:', err)
      })

      // 下载文件
      const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro
      const downloadUrl = `${baseUrl}file/download?filePath=${encodeURIComponent(this.preprint.manuscriptFilePath)}`
      window.open(downloadUrl, '_blank')
      this.$message.success('开始下载文件')
    },
    submitComment() {
        if (!this.commentContent.trim()) {
        this.$message.warning(this.$t('preprint.detailCommentEmpty'))
        return
      }

      this.submittingComment = true
      submitComment({
        userInfo: {
          email: this.userInfo.email,
          name: this.userInfo.name
        },
        preprintId: this.preprintId,
        commentContent: this.commentContent
      }).then((res) => {
        if (res.data.errorCode === 0) {
          this.$message.success(this.$t('preprint.detailCommentSuccess'))
          this.commentContent = ''
        } else {
          this.$message.error(res.data.errorMessage || this.$t('preprint.detailCommentFailed'))
        }
      }).catch((err) => {
        console.error('提交评论错误:', err)
        this.$message.error(this.$t('preprint.detailCommentFailed'))
      }).finally(() => {
        this.submittingComment = false
      })
    },
    canDeleteComment(comment) {
      // 未登录用户不能删除
      if (!this.userInfo) {
        return false
      }
      
      // 评论本人可以删除
      if (comment.commenterEmail === this.userInfo.email) {
        return true
      }
      
      // 责任编辑(管理员)可以删除所有人的评论
      const userType = this.userInfo.type
      if (userType === '责任编辑') {
        return true
      }
      
      return false
    },
    handleDeleteComment(commentId) {
      this.$confirm(
        this.$t('preprint.detailDeleteCommentConfirm'),
        this.$t('preprint.detailDeleteComment'),
        {
          confirmButtonText: this.$t('preprint.detailDeleteComment'),
          cancelButtonText: this.$t('preprint.pendingDialogCancel'),
          type: 'warning'
        }
      ).then(() => {
        deleteComment({
          userInfo: {
            email: this.userInfo.email,
            type: this.userInfo.type
          },
          commentId: commentId
        }).then((res) => {
          if (res.data.errorCode === 0) {
            this.$message.success(this.$t('preprint.detailDeleteCommentSuccess'))
            // 重新加载评论列表
            this.loadComments()
          } else {
            this.$message.error(res.data.errorMessage || this.$t('preprint.detailDeleteCommentFailed'))
          }
        }).catch((err) => {
          console.error('删除评论错误:', err)
          this.$message.error(this.$t('preprint.detailDeleteCommentFailed'))
        })
      }).catch(() => {
        // 用户取消删除
      })
    }
  },
  mounted() {
    this.preprintId = this.$route.query.id
    if (!this.preprintId) {
      this.$message.error(this.$t('preprint.detailMissingId'))
      this.$router.go(-1)
      return
    }

    // 获取用户信息
    this.userInfo = this.$cookie.getCookie('userInfo')

    // 加载预印本详情
    this.loadPreprintDetail()
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin-top: 12px;
  .mydoc {
    border-radius: 4px;
    min-height: 20rem;
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    text-align: left;
    .mybody {
      min-height: 800px;
      padding: 20px;
      background-color: white;
      overflow: auto;
    }
  }
}
.header {
  padding: 10px;
  text-align: left;
  background-color: gainsboro;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px solid gainsboro;
}
</style>



// WEBPACK FOOTER //
// src/view/preprint/preprintDetail.vue